import { OnInit, Directive } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { ConnectionCheck } from '../utils/connection-check';

@Directive()
export class BaseMenuComponent implements OnInit {
  public selectedGroup: string = null;
  constructor(public modal: ModalComponent) {}

  ngOnInit(): void {}

  selectMenu(item: any): void {
    this.modal.close(item);
  }

  public showGroup(event: Event, groupName: string) {
    event.stopPropagation();
    this.selectedGroup = groupName;
  }

  public isVisible(groupName: string): boolean {
    return this.selectedGroup === groupName;
  }

  public getData(): any {
    return null;
  }

  public get isConnection() {
    return ConnectionCheck.isConnection;
  }
}
